/**
 * Bandera de "estoy sincronizando", en su propio módulo para que baseApi no tenga que
 * importar al sincronizador (que a su vez importa los endpoints, que salen de baseApi).
 *
 * Mientras está puesta, la capa offline NO intercepta: si lo hiciera, cada petición de la
 * sincronización se volvería a encolar y la cola no se vaciaría nunca.
 */
let syncing = false;

export const isSyncingOfflineQueue = (): boolean => syncing;

export const setSyncingOfflineQueue = (value: boolean): void => { syncing = value; };
